import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  'saw.persons.person': {
    id: 'person',
    defaultMessage: '{count, plural, one {# person} other {# persons}}',
  },
  'saw.persons.project': {
    id: 'project',
    defaultMessage: '{count, plural, one {# project} other {# projects}}',
  },
  'News Item': {
    id: 'news-item',
    defaultMessage: '{count, plural, one {# news item} other {# news items}}',
  },
  Event: {
    id: 'event',
    defaultMessage: '{count, plural, one {# event} other {# events}}',
  },
  Document: {
    id: 'document',
    defaultMessage: '{count, plural, one {# document} other {# documents}}',
  },
  File: {
    id: 'file',
    defaultMessage: '{count, plural, one {# file} other {# files}}',
  },
  Image: {
    id: 'image',
    defaultMessage: '{count, plural, one {# image} other {# images}}',
  },
  'saw.persons.workgroup': {
    id: 'workgroup',
    defaultMessage: '{count, plural, one {# workgroup} other {# workgroups}}',
  },
  portal_type: {
    id: 'portal-type',
    defaultMessage: 'Inhaltstyp',
  },
  taxonomy_person_type: {
    id: 'taxonomy-person-type',
    defaultMessage: 'Type of person',
  },
  taxonomy_project_type: {
    id: 'taxonomy-project-type',
    defaultMessage: 'Type of project',
  },
  groupResults: {
    id: 'group-results',
    defaultMessage: 'Group results',
  },
  shortListing: {
    id: 'short-listing',
    defaultMessage: 'Short listing',
  },
  filterby: {
    id: 'Filter By:',
    defaultMessage: 'Filter By:',
  },
  ViewSettings: {
    id: 'ViewSettings',
    defaultMessage: 'View settings',
  },
  reset: {
    id: 'form_reset',
    defaultMessage: 'Clear',
  },
  altText: {
    id: 'altText',
    defaultMessage:
      'Please insert the alternative text of the image to complete upload.',
  },
  gebaerdensprache: {
    id: 'gebaerdensprache',
    defaultMessage: 'Gebärdensprache',
  },
  leichteSprache: {
    id: 'leichteSprache',
    defaultMessage: 'Leichte Sprache',
  },
});

export default messages;
